<template>
  <el-dialog
    id="createTestCollectionOrderDialog"
    :title="$t('text.restoreOrdersFromCold')"
    :visible="isShowOrderRestorationDialog"
    width="600px"
    @open="openDialog"
    @close="closeDialog"
    :close-on-click-modal="false"
  >
    <div class="order-restore-dialog-tip">
     {{ $t('text.restoreOrdersFromColdTip') }}
    </div>
    <el-form
      ref="form"
      :model="search"
      label-width="150px"
      v-show="submitted === false"
    >
      <el-form-item>
        <el-radio-group
          v-model="search.field"
          @change="
            search.value = '';
            $refs.form.resetFields();
            searchData = [];
          "
        >
          <el-radio label="orderId">{{ $t("text.orderNumber") }}</el-radio>
          <el-radio label="merchantOrderId">{{
            $t("text.merchantOrderNumber")
          }}</el-radio>
          <el-radio label="channelOrderId">{{
            $t("text.channelOrderNumber")
          }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item
        prop="value"
        :rules="{ required: true, message: placeholder, trigger: 'blur' }"
        :error="search.error"
      >
        <el-input
          v-model="search.value"
          auto-complete="off"
          :placeholder="placeholder"
          @focus="search.error = ''"
        >
          <el-button slot="append" icon="el-icon-search" @click="handleSearch"
            >{{ $t("text.searchFor") }}</el-button
          >
        </el-input>
      </el-form-item>
    </el-form>
    <div v-loading="search.loading">
      <el-table
        highlight-current-row
        v-if="searchData.length > 1"
        :data="searchData"
        style="width: 100%"
        @current-change="(row) => (form.orderId = row.orderId)"
      >
        <el-table-column width="50px" prop="check">
          <template slot-scope="scope">
            <el-checkbox :value="form.orderId === scope.row.orderId" />
          </template>
        </el-table-column>
        <el-table-column :prop="search.field" :label="label"> </el-table-column>
        <el-table-column
          prop="amount"
          :formatter="$formatter.FenToYuanToThousandth"
          :label="$t('text.orderAmount')"
        >
        </el-table-column>
        <el-table-column prop="customerName" :label="$t('text.customerName')">
        </el-table-column>
      </el-table>
      <div class="search-info" v-if="searchData.length === 1">
        <div class="search-info-item">
          <span class="info-left">{{ label }}</span>
          <span class="info-right">{{ searchData[0][search.field] }}</span>
        </div>
        <div class="search-info-item">
          <span class="info-left">{{ $t("text.orderAmount") }}</span>
          <span class="info-right">{{ searchData[0].amount }}</span>
        </div>
        <div class="search-info-item">
          <span class="info-left">{{ $t("text.customerName") }}</span>
          <span class="info-right">{{ searchData[0].customerName }}</span>
        </div>
        <div class="search-info-item">
          <span class="info-left">{{ $t("text.customerCert") }}</span>
          <span class="info-right">{{ searchData[0].customerCert }}</span>
        </div>
      </div>
    </div>

    <div class="dialog-footer" v-if="submitted === false">
      <el-button @click="closeDialog" >{{ $t("text.cancel") }}</el-button>
      <el-button type="primary" :loading="loading" :disabled="!searchData.length" @click="submit"
        >{{ $t("text.confirm") }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShowOrderRestorationDialog: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    placeholder() {
      return this.search.field === "orderId"
        ? this.$t("message.inputOrderId")
        : this.search.field === "merchantOrderId"
        ? this.$t("message.inputMerchantOrderId")
        : this.$t("message.inputChannelOrderIdForQuery");
    },
    label() {
      return this.search.field === "orderId"
        ? this.$t("text.merchantOrderNumber")
        : this.search.field === "merchantOrderId"
        ? this.$t("text.merchantOrderNumber")
        : this.$t("text.channelOrderNumber");
    },
  },

  data() {
    return {
      search: {
        field: "orderId",
        value: "",
        error: "",
        loading:false
      },
      form: {
        orderId: "",
        merchantOrderId: "",
        channelOrderId: "",
      },
      loading: null,
      title: "",
      submitted: false,
      result: {
        success: false,
        message: "",
        link: "",
      },
      searchData: [],
    };
  },
  methods: {
    lockDialog() {
      this.loading = this.$loading({
        lock: true,
        text: this.$t("text.loading"),
        spinner: "el-icon-loading",
        target: "#createTestCollectionOrderDialog .el-dialog",
      });
    },
    unlockDialog() {
      if (this.loading !== null) {
        this.loading.close();
        this.loading = null;
      }
    },
    openDialog() {
      this.title = this.$t("text.testOrder");
      this.submitted = false;
      this.result = {
        success: false,
        message: "",
        link: "",
      };
    },
    closeDialog() {
      this.search = {
        value: "",
        field: "orderId",
        error: "",
        loading:false
      };
      this.form = {
        orderId: "",
        merchantOrderId: "",
        channelOrderId: "",
      };
      this.searchData = [];
      this.$refs.form.resetFields();
      this.$emit("update:isShowOrderRestorationDialog", false);
    },
    handleSearch() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$set(this.search, 'loading', true);
          let params = {
            orderId: "",
            merchantOrderId: "",
            channelOrderId: "",
          };
          params[this.search.field] = this.search.value;
          this.$axios
            .get("/order/selectArchivedOrder", { params })
            .then((res) => {
              if (res.code === 200) {
                this.searchData = res.data || [];
                this.form.orderId = this.searchData[0].orderId;
              } else {
                this.search.error = this.$t( "text.orderNumberNotFound");
              }
            })
            .catch((e) => {
              console.log(e, "error");
            })
            .finally(()=>{
              this.$set(this.search, 'loading', false);
             
            });
        } else {
          return false;
        }
      });
    },
    submit() {
      this.$axios
        .post("/order/recoveryOrder", this.form)
        .then((res) => {
          this.lockDialog();
          if (res.code === 200) {
            this.$bus.$emit("refresh");
            this.closeDialog();
            this.$notify({
              title: `${this.$t("text.operationSuccessful")}`,
              message: `${this.$t("text.syncOrderSuccessMessage",{orderId:this.form.orderId})}`,
              type: "success",
            });
            return true;
          } else {
            this.$notify.error({
              title: this.$t("text.prompt"),
              message: res.msg,
            });
            return false;
          }
        })
        .catch(() => {
          this.unlockDialog();
          this.$notify.error({
            title: this.$t("text.prompt"),
            message: this.$t("message.sysError"),
          });
        }).finally(this.unlockDialog);
    },

    mounted() {
      this.openDialog();
    },
  },
};
</script>
<style scoped lang="scss">
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 40px;
}
.order-restore-dialog-tip {
  background-color: #ecf5ff;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 600;
  color: #409eff;
  padding: 9px 16px;
  margin-top: -18px;
  margin-bottom: 12px;
}
::v-deep .el-form-item__content {
  margin-left: 0 !important;
}
.search-info {
  .search-info-item {
    font-size: 14px;
    margin-top: 8px;
    .info-left {
      display: inline-block;
      width: 80px;
    }
  }
}
</style>
